// This function add a space to a pascal case string
export const addSpaceToPascalCase = (string) => {
  return string.replace(/([A-Z])/g, ' $1').trim();
};
